<template>
    <b-btn v-if="isAvailable" :to="{ name: 'Fl44UnknownVolumePurchaseDurationChange', params: { id: purchase.id } }" class="btn-card-action btn-card-action-light my-1">Сделать не срочной</b-btn>
</template>

<script>
export default {
    name: 'cabinet-fl44-notice-card-duration-change-button',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    computed: {
        isAvailable() {
            return this.purchase.actions.duration_change;
        }
    }
};
</script>
